import React from 'react';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';

const propTypes = {    
    autoFocus: PropTypes.bool,          // Focus on input on load
    className: PropTypes.string,        // Custom class name to add to input container
    disabled: PropTypes.bool,           // Disable input
    disableEmptyOption: PropTypes.bool, // if true , it does not show the first option as empty
    id: PropTypes.string,               // Input id    
    inputErrorMsg: PropTypes.string,    // Input inline error message    
    name: PropTypes.string,             // Input name   
    onChange: PropTypes.func,           // Function triggered on onChange     
    onFocus: PropTypes.func,            // Function triggered on focus
    options: PropTypes.array,           // options to be displayed
    placeholder: PropTypes.string,      // Input placeholder text
    prependIcon: PropTypes.string,      // class of icon
    renderedOptions: PropTypes.array,   // array with <option> tags to be displayed
    required: PropTypes.bool,           // Set to true so input empty validation check will trigger on blur and keypress
    showAsInvalid: PropTypes.bool,      // Override component validation and display input as invalid    
    tooltipID: PropTypes.string,        // Tooltip id which is required to display tooltip message
    tooltipMsg: PropTypes.string,       // Tooltip message   
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) // Input value
};

export default class Select extends React.Component {
    constructor(props) {
        super(props);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.validateOnMount = this.validateOnMount.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput: false,
            touched: false,
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.validateOnMount();
    }

    toggleToolTip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onChange(event) {
        if (this.props.onChange)
            this.props.onChange(event, event.target.value, event.target.value.trim() !== '');
        this.validateOnBlur(event);
    }

    validateOnBlur(event) {
        if (this.props.required) {
            event.persist();
            if (event.target.value) {
                this.setState({ invalidInput: false });
            }
            else {
                this.setState({ invalidInput: true });
            }
        }
        this.setState({
            touched: true
        });
    }

    validateOnMount() {
        const value = this.props.value;
        if (this.props.required) {
            const isValid = value  ? true : false;        
            this.setState({ invalidInput: !isValid });
        }
    }

    render() {
        const { placeholder, required, name, id, autoFocus, disabled, disableEmptyOption, value, options,
            renderedOptions, className, inputErrorMsg, tooltipID, tooltipMsg, prependIcon, showAsInvalid, onFocus
        } = this.props;
        var dynamicClass = className ? className : '';
        
        const containerClassName = (value || value === 0 ? " input-not-empty" : " input-empty") + (this.state.touched ? " input-touched" : " input-untouched") + (this.state.invalidInput || showAsInvalid ? " input-invalid" : " input-valid") + ((tooltipID && tooltipMsg) ? " input-append" : "");

        return (
            <div className={"il-group" + containerClassName}>
                    <select
                        className={"form-control " + dynamicClass}
                        required={required}
                        name={name}
                        id={id || name}
                        value={value}
                        disabled={disabled}
                        autoFocus={autoFocus}
                        aria-label={placeholder ? placeholder : ""}
                        onChange={e => this.onChange(e)}
                        onBlur={this.validateOnBlur}
                        onFocus={(e) => { if (onFocus) onFocus(e); }}
                        title={placeholder ? "Please fill out the " + placeholder : "Please fill out this field."}
                        ref="selectElement"
                    >
                        {!disableEmptyOption && <option value="" />}
                        {options && options.length > 0 ? options.map((opt, index) => {
                            return (
                                <option
                                    key={index}
                                    value={opt.value}>{opt.label}</option>
                            );
                        }) : renderedOptions}
                    </select>
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleToolTip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                <div className="il-label" aria-hidden="true">{prependIcon && <span className={prependIcon} />} {placeholder}</div>
                {this.state.invalidInput && (typeof value !== "undefined" && value !== "") ? <div className="input-error-msg" htmlFor={id} tabIndex="0">{inputErrorMsg ? inputErrorMsg : `Please select a valid ${placeholder}.`}</div> : null}
            </div>
        );
    }
}

Select.PropTypes = propTypes;